// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  #progress-bar-container li .step-inner {
    position: absolute;
    width: 100%;
    bottom: 0;
    font-size: 14px;
    background-color: #fff;
  }
  
  #progress-bar-container li.active,
  #progress-bar-container li:hover {
    color: #000;
  }
  
  #progress-bar-container li::after {
    content: " ";
    display: block;
    width: 6px;
    height: 6px;
    background-color: white;
    margin: auto;
    border: 7px solid #fff;
    border-radius: 50%;
    margin-top: 40px;
    transition: all ease 0.25s;
  }
  #progress-bar-container li:hover::after {
    background: transparent;
  }
  
  #progress-bar-container li.active::after {
    background: #03AC13;
  }
  
  #progress-bar-container #line {
    width: 80%;
    margin: auto;
    background-color: #eee;
    height: 6px;
    position: absolute;
    left: 10%;
    top: 57px;
    z-index: 1;
    border-radius: 50px;
    transition: all ease 0.75s;
  }
  
  #progress-bar-container #line-progress {
    content: " ";
    width: 8%;
    height: 100%;
    background-color: #207893;
    background: linear-gradient(to right #207893 0%, #2ea3b7 100%);
    position: absolute;
    z-index: 2;
    border-radius: 50px;
    transition: 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.25);
  }
  #progress-content-section {
    position: relative;
    top: 100px;
    width: 90%;
    margin: auto;
    background: #f3f3f3;
    border-radius: 4px;
  }
  #progress-content-section .section-content {
    padding: 30px 40px;
    text-align: center;
  }
  
  .section-content h2 {
    font-size: 17px;
    text-transform: uppercase;
    color: #333;
    letter-spacing: 1px;
  }
  
  .section-content p {
    font-size: 16px;
    line-height: 1.8rem;
    color: #777;
  }
  
  .section-content {
    display: none;
    animation: FadeinUp 0.7s ease 1 forwards;
    transform: translateY(15px);
    opacity: 0;
  }
  
  .section-content.active {
    display: block;
    opacity: 1;
  }
  .progress-wrapper {
    margin: auto;
    max-width: 1080px;
  }
  #progress-bar-container {
    position: relative;
    width: 90%;
    margin: auto;
    height: 100%;
    margin-top: 65px;
  }
  #progress-bar-container ul {
    padding-top: 15px;
    z-index: 999;
    position: absolute;
    width: 100%;
    margin-top: -40px;
  }
  #progress-bar-container li::before {
    content: " ";
    display: block;
    margin: auto;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid #aaa;
    transition: all ease 0.3s;
  }
  
  #progress-bar-container li.active::before,
  #progress-bar-container li:hover::before {
    border: 2px solid #fff;
    background-color: crimson;
  }
  #progress-bar-container li {
    list-style: none;
    float: left;
    width: 33%;
    text-align: center;
    color: #aaa;
    text-transform: uppercase;
    font-size: 11px;
    cursor: pointer;
    font-weight: 700;
    transition: all ease 0.2s;
    vertical-align: bottom;
    height: 60px;
    position: relative;
  }
  @keyframes FadeInUp {
    0% {
      transform: translateY(15px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/body/pages/stepper.css"],"names":[],"mappings":";EACE;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,8DAA8D;IAC9D,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,uDAAuD;EACzD;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,wCAAwC;IACxC,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE;MACE,2BAA2B;MAC3B,UAAU;IACZ;IACA;MACE,0BAA0B;MAC1B,UAAU;IACZ;EACF","sourcesContent":["\n  #progress-bar-container li .step-inner {\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    font-size: 14px;\n    background-color: #fff;\n  }\n  \n  #progress-bar-container li.active,\n  #progress-bar-container li:hover {\n    color: #000;\n  }\n  \n  #progress-bar-container li::after {\n    content: \" \";\n    display: block;\n    width: 6px;\n    height: 6px;\n    background-color: white;\n    margin: auto;\n    border: 7px solid #fff;\n    border-radius: 50%;\n    margin-top: 40px;\n    transition: all ease 0.25s;\n  }\n  #progress-bar-container li:hover::after {\n    background: transparent;\n  }\n  \n  #progress-bar-container li.active::after {\n    background: #03AC13;\n  }\n  \n  #progress-bar-container #line {\n    width: 80%;\n    margin: auto;\n    background-color: #eee;\n    height: 6px;\n    position: absolute;\n    left: 10%;\n    top: 57px;\n    z-index: 1;\n    border-radius: 50px;\n    transition: all ease 0.75s;\n  }\n  \n  #progress-bar-container #line-progress {\n    content: \" \";\n    width: 8%;\n    height: 100%;\n    background-color: #207893;\n    background: linear-gradient(to right #207893 0%, #2ea3b7 100%);\n    position: absolute;\n    z-index: 2;\n    border-radius: 50px;\n    transition: 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.25);\n  }\n  #progress-content-section {\n    position: relative;\n    top: 100px;\n    width: 90%;\n    margin: auto;\n    background: #f3f3f3;\n    border-radius: 4px;\n  }\n  #progress-content-section .section-content {\n    padding: 30px 40px;\n    text-align: center;\n  }\n  \n  .section-content h2 {\n    font-size: 17px;\n    text-transform: uppercase;\n    color: #333;\n    letter-spacing: 1px;\n  }\n  \n  .section-content p {\n    font-size: 16px;\n    line-height: 1.8rem;\n    color: #777;\n  }\n  \n  .section-content {\n    display: none;\n    animation: FadeinUp 0.7s ease 1 forwards;\n    transform: translateY(15px);\n    opacity: 0;\n  }\n  \n  .section-content.active {\n    display: block;\n    opacity: 1;\n  }\n  .progress-wrapper {\n    margin: auto;\n    max-width: 1080px;\n  }\n  #progress-bar-container {\n    position: relative;\n    width: 90%;\n    margin: auto;\n    height: 100%;\n    margin-top: 65px;\n  }\n  #progress-bar-container ul {\n    padding-top: 15px;\n    z-index: 999;\n    position: absolute;\n    width: 100%;\n    margin-top: -40px;\n  }\n  #progress-bar-container li::before {\n    content: \" \";\n    display: block;\n    margin: auto;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: 2px solid #aaa;\n    transition: all ease 0.3s;\n  }\n  \n  #progress-bar-container li.active::before,\n  #progress-bar-container li:hover::before {\n    border: 2px solid #fff;\n    background-color: crimson;\n  }\n  #progress-bar-container li {\n    list-style: none;\n    float: left;\n    width: 33%;\n    text-align: center;\n    color: #aaa;\n    text-transform: uppercase;\n    font-size: 11px;\n    cursor: pointer;\n    font-weight: 700;\n    transition: all ease 0.2s;\n    vertical-align: bottom;\n    height: 60px;\n    position: relative;\n  }\n  @keyframes FadeInUp {\n    0% {\n      transform: translateY(15px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateY(0px);\n      opacity: 1;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
